import { createContext } from "preact/compat";
export const TableContext = createContext({
  stackable: false,
  warningDisabled: false
});
export default TableContext;